import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { ProjectOutlined } from '@vicons/antd';
import { PricetagOutline, BusinessOutline } from '@vicons/ionicons5';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.prefix 菜单名称前缀, 用于确定唯一名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/project',
    name: 'project',
    redirect: '/project/room',
    component: Layout,
    meta: {
      title: 'Project',
      icon: renderIcon(ProjectOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: ['project_room_read', 'project_item_read'],
      sort: 3,
    },
    children: [
      {
        path: 'room',
        name: 'project_room',
        meta: {
          title: 'Room',
          prefix: 'Project',
          icon: renderIcon(BusinessOutline),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['project_room_read'],
        },
        component: () => import('@/views/project/room/index.vue'),
      },
      {
        path: 'item',
        name: 'project_item',
        meta: {
          title: 'Item',
          prefix: 'Project',
          icon: renderIcon(PricetagOutline),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['project_item_read'],
        },
        component: () => import('@/views/project/item/index.vue'),
      },
    ],
  },
];

export default routes;
